import axios from "axios";
import { useQuery } from "react-query";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { TPackage } from "../types";
import { END_POINT } from "config/environment";

export const QUERY_KEY_FOR_PACKAGE = "package";

const getData = async (props: {
  token: string;
}): Promise<TPackage[]> => {
  const url = `${END_POINT.BASE_URL}/v1/administrator/packages`;
  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
    },
  };
  const res = await axios.get(url, config);
  const item: TPackage[] = res.data;
  return item;
};

export const useGetPackage = () => {
  const { token, userInfo } = useGetUserInfo();
  const queryData = useQuery(
    [QUERY_KEY_FOR_PACKAGE],
    () => getData({
        token,
    }),
    {
      onError: (err: any) => {},
      onSuccess: (data) => {},
    }
  );
  return queryData;
};
